<template>
    <v-card outlined tile :to="to" class="card-board h-100">
        <v-layout column :justify-space-between="imageBoard" class="h-100 white">
            <div class="w-100">
                <div v-if="imageBoard">
                    <v-img :aspect-ratio="280 / 128" contain :src="src" />
                </div>
                <v-divider v-if="imageBoard" class="border-light" />
                <div class="card-board__contents pb-0" :class="[imageBoard ? 'min-h-140px min-h-md-160px' : '']">
                    <div class="h-34px">
                        <v-chip v-if="chip" x-small outlined color="secondary"><i class="icon icon-award mr-4px" /><span class="font-size-14">{{ chip }}</span></v-chip>
                    </div>
                    <div>
                        <div v-if="title" class="tit tit--xxs font-weight-extrabold text-truncate-2">{{ title }}</div>
                        <slot name="titleSlot" />
                        <div v-if="text" :class="imageBoard ? 'txt txt--lg txt--dark text-truncate-2 mt-4px mt-md-10px' : 'txt txt--sm text-truncate-3 mt-4px mt-md-10px'">{{ text }}</div>
                        <slot name="textSlot" />
                        <div v-if="teamName" class="txt txt--sm text-truncate-3 mt-4px mt-md-10px">{{ teamName }}</div>
                    </div>
                </div>
            </div>
            <div v-if="view || this.$slots['hash']" class="card-board__contents" :class="imageBoard ? 'pt-12px pt-md-20px' : 'pt-0'">
                <slot name="hash" />
                <v-layout v-if="view" align-center class="mt-4px mt-md-10px">
                    <i class="icon icon-view mr-4px" />
                    <p class="txt txt--xs txt--light">{{ view }}</p>
                </v-layout>
            </div>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    props: {
        imageBoard: { type: Boolean },
        to: { type: String },
        src: { type: String, default: "/images/common/common-noimg.jpg" },
        chip: { type: String },
        title: { type: String },
        text: { type: String },
        textLg: { type: String },
        teamName: { type: String },
        view: { type: String },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.card-board {
    border: 1px solid var(--border-color-light);
    -webkit-transition: all ease-out 0.2s;
    -ms-transition: all ease-out 0.2s;
    transition: all ease-out 0.2s;
    &:hover {
        border-color: var(--v-primary-base);
    }
    &__contents {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 16px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .card-board {
        &__contents {
            padding: 24px;
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
